
import { useAuth } from "@/context/auth";
import { useDataFetching } from "./useDataFetching";
import { useRetryLogic } from "./useRetryLogic";
import { useContentState } from "./useContentState";
import { FolderContentResult } from "./types";

export interface UseFolderContentProps {
  folderId: string;
  projectId?: string;
}

export function useFolderContent({ folderId, projectId }: UseFolderContentProps): FolderContentResult {
  const { user } = useAuth();
  
  // Data fetching
  const {
    folder,
    subfolders,
    assessments,
    parentFolder,
    shareDetails,
    owner,
    error,
    isLoading,
    refetch
  } = useDataFetching({ folderId, projectId });

  // Retry logic for handling errors
  const { isRetrying, retryFetch } = useRetryLogic({
    error,
    refetch
  });

  // Combine into a single state object
  const state = useContentState({
    folder,
    subfolders,
    assessments,
    parentFolder,
    shareDetails,
    owner,
    error,
    isLoading,
    isRetrying
  });

  return {
    ...state,
    refetch: () => {
      if (user) {
        refetch();
      } else {
        console.error("User is not authenticated");
      }
    },
    refreshData: () => {
      if (user) {
        refetch();
      } else {
        console.error("User is not authenticated");
      }
    }
  };
}
